import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import React from "react";
interface Props {
  artist: server.dto.ArtistSmall
  displayTooltip: boolean
}

const ReadonlyArtist = (props: Props) => {
  if (props.artist == null) {
    return <div className="s1_gray">{RESX.Company.NoCompanySelected}</div>;
  }

  return <div className="flex gap">
    {props.displayTooltip && <CompanySidePanel type="artist"
      companyId={props.artist.artistId}
      trigger={<a>{props.artist.name}</a>}
      fallbackIfNoPermission={<strong>{props.artist.name}</strong>}
    />}
    {!props.displayTooltip && <strong>{props.artist.name}</strong>}
  </div>;
};

export default ReadonlyArtist;